<!-- 用户配置 -->
<template>
  <div>
    <div>
      <div class="p_row" style="display: flex;justify-content:space-around;">
        <span class="sp">总量：{{addParams.oriNewUserCount}}</span>
        <span class="sp">扣量：{{addParams.dedNewUserCount}}</span>
        <span class="sp">计划扣量：{{addParams.preDedNewUserCount}}</span>
      </div>
      <div style="margin-left:4px;color:#000"></div>
      <el-divider></el-divider>
    </div>
    <!-- 扣新增用户折线图 -->
    <div
      class="line1"
      ref="regChart1"
      style="width:560px;height:320px;margin-left:-30px;margin-bottom:15px"
    ></div>
    <!-- 扣新增用户折线图下方表单 -->
    <el-form :model="userParam" label-width="120px" ref="userForm" :label-position="labelPosition">
      <el-form-item label="采用时间:">
        <el-date-picker
          style="width:250px"
          size="small"
          v-model="time"
          type="daterange"
          range-separator="——"
          start-placeholder="开始日期"
          end-placeholder="结束日期:"
          @change="changeTime"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="起扣时间:">
        <el-date-picker
          v-model="userParam.nuDedAt"
          type="datetime"
          placeholder="选择日期时间"
          @change="nuDedTime()"
          size="small"
        ></el-date-picker>
      </el-form-item>

      <el-form-item label="扣量起点(个):">
        <el-input-number
          v-model.number="userParam.nuDedLowerOutset"
          @change="userChartData()"
          placeholder="输入数字"
          :precision="0"
          :step="1"
          :min="0"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="扣量比:">
        <el-input-number
          v-model="userParam.nuDeductionRatio"
          placeholder="输入数字"
          @change="userChartData()"
          :precision="2"
          :step="0.01"
          :max="1"
          :min="0"
          size="small"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="开关:">
        <el-switch
          v-model="active"
          active-color="#13ce66"
          inactive-color="#666666"
          active-text="开启"
          inactive-text="关闭"
        ></el-switch>
      </el-form-item>
      <el-form-item class="myFooter" style="position: absolute;bottom: -35px;right: 20px;">
        <!-- <el-button size="small">取 消</el-button> -->
        <el-button type="primary" @click="submitForm('userForm')" :loading="flag" size="small">保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import API from "@/api";
import echarts from "echarts";
import { changeTime, changeSumDate } from "@/utils/global";
export default {
  props: ["querry", "userTime"],
  data() {
    return {
      active: "",
      labelPosition: "left",
      // 提交按钮状态
      flag: false,
      time: "", //采用时间
      addParams: {}, //图表上方需要展示字段
      userParam: {
        id: "", //唯一码
        discCode: "",
        nuDeductionRatio: 0, //充值扣量比例
        nuDedLowerOutset: 0, //充值扣量起点
        nuDedAt: "" //充值扣量时间
      },
      nuDedAnalysis: {}
    };
  },
  created() {
    this.intUser();
  },
  methods: {
    submitForm(userForm) {
      this.$refs[userForm].validate(valid => {
        if (valid) {
          this.editUser();
        } else {
          return false;
        }
      });
    },
    editUser() {
      let param = Object.assign({}, this.userParam, {
        deductType: this.active === true ? 2 : 0
      });
      API.updateDedNewUser(param)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑用户配置成功！",
              type: "success"
            });
            this.$emit("editPage");
          } else {
            this.$message.error("编辑用户配置失败！");
          }
          this.flag = false;
        })
        .catch(() => {
          this.flag = false;
        });
    },

    //扣用户--采样时间回掉
    changeTime(time) {
      this.nuDedAnalysis.startTime = time[0]
        ? changeSumDate(time[0])
        : undefined;
      this.nuDedAnalysis.endTime = time[1] ? changeSumDate(time[1]) : undefined;
      this.userChartData();
    },
    //扣用户--起扣时间
    nuDedTime() {
      this.userChartData();
    },
    userChartData() {
      // 初始化echart实例
      let myChart = echarts.init(this.$refs.regChart1);
      const subTit = "注册趋势图";
      myChart.showLoading({
        text: "拼命加载中",
        color: "#d54867",
        textColor: "#d54867",
        maskColor: "rgba(255,255,255,0.8)",
        zlevel: 0
      });
      // 折线图数据接口
      // 获取新增扣用户数据 this.userParam.nuAnalysisData.discCode = this.querry.districtCode;
      const param = {
        startTime: changeSumDate(this.time[0]),
        endTime: changeSumDate(this.time[1]),
        discCode: this.userParam.discCode,
        dedLowerOutset: this.userParam.nuDedLowerOutset,
        nuDedAt: changeTime(this.userParam.nuDedAt),
        nuDedRatio: this.userParam.nuDeductionRatio
      };
      let getLineChartData = API.handleNewUserAnalysis(param);
      getLineChartData
        .then(res => {
          if (res.code == 200) {
            let time = [];
            // 新增用户要展示字段
            this.addParams = {
              oriNewUserCount: res.data.oriNewUserCount,
              dedNewUserCount: res.data.dedNewUserCount,
              preDedNewUserCount: res.data.preDedNewUserCount
            };
            let oriNewUserCountMap = [];
            let oriDedNewUserCountMap = [];
            let preDedNewUserCountMap = [];
            let tit = [];
            tit.push("原始");
            tit.push("扣量");
            tit.push("计划");

            Object.keys(res.data.oriNewUserCountMap).forEach(key => {
              time.push(key + "h");
              if (res.data.oriNewUserCountMap[key] !== undefined) {
                oriNewUserCountMap.push(res.data.oriNewUserCountMap[key]);
              }
              if (res.data.oriDedNewUserCountMap[key] !== undefined) {
                oriDedNewUserCountMap.push(res.data.oriDedNewUserCountMap[key]);
              }
              if (res.data.preDedNewUserCountMap[key] !== undefined) {
                preDedNewUserCountMap.push(res.data.preDedNewUserCountMap[key]);
              }
            });
            myChart.hideLoading();
            let option = {
              title: {
                text: `${subTit}`
              },
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  label: {
                    backgroundColor: "#6a7985"
                  }
                }
              },

              color: ["#1e9f38", "#111110", "#c51f00"],
              legend: {
                data: [tit[0], tit[1], tit[2]]
              },
              xAxis: {
                min: -1,
                type: "category",
                boundaryGap: false,
                data: time,
                axisLine: { onZero: false }
              },
              yAxis: {
                min: -1,
                type: "value",
                axisLabel: {
                  formatter: "{value} "
                },
                axisLine: { onZero: false }
              },
              series: [
                {
                  name: tit[0],
                  type: "line",
                  smooth: true,
                  data: oriNewUserCountMap,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" }
                    ]
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }]
                  }
                },
                {
                  name: tit[1],
                  type: "line",
                  smooth: true,
                  data: oriDedNewUserCountMap,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" }
                    ]
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }]
                  }
                },
                {
                  name: tit[2],
                  type: "line",
                  smooth: true,
                  data: preDedNewUserCountMap,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" }
                    ]
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }]
                  }
                }
              ]
            };
            myChart.setOption(option);
          } else {
            myChart.showLoading({
              text: "暂无数据",
              color: "rgba(250,250,250,0.1)",
              textColor: "#8a8e91",
              maskColor: "rgba(255, 255, 255, 0.8)"
            });
            this.load = false;
          }
        })
        .catch(() => {
          myChart.showLoading({
            text: "暂无数据",
            color: "rgba(250,250,250,0.1)",
            textColor: "#8a8e91",
            maskColor: "rgba(255, 255, 255, 0.8)"
          });
          this.load = false;
        });
    },
    // handleClose() {
    //   this.userParam.id = ""; //唯一码
    //   this.userParam.nuDeductionRatio = 0; //充值扣量比例
    //   this.userParam.nuDedLowerOutset = 0; //充值扣量起点
    //   this.userParam.nuDedAt = ""; //充值扣量时间
    //   this.userParam.nuAnalysisData.startTime = ""; //采样开始时间
    //   this.userParam.nuAnalysisData.endTime = ""; //采样结束时间
    // },

    updateUserParam(val) {
      this.userParam = {
        nuDeductionRatio: val.nuDeductionRatio,
        nuDedLowerOutset: val.nuDedLowerOutset,
        nuDedAt: val.nuDedAt,
        id: val.id,
        discCode: val.districtCode
      };
      this.time = this.userTime;
      this.active = Boolean(val.deductType & 2);
    },
    intUser() {
      this.updateUserParam(this.querry);
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    querry: function(val, oldVal) {
      this.updateUserParam(val);
    }
  }
};
</script>

<style lang='' scoped>
</style>